import { components, useApi } from "@appretio/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateCubeMutation } from "../cubeMutationInvalidation";

type TrimCubeInput = components["schemas"]["TrimCubeInput"];

export function useTrimCube() {
  const apiClient = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: TrimCubeInput) => {
      const response = await apiClient.POST("/v2/forecast/cubes/trim", {
        body: input
      });
      if (!response.data?.result) {
        throw new Error("Missing result in trim cube response");
      }
      return response.data.result;
    },
    onSuccess: async () => {
      await invalidateCubeMutation(queryClient, { lifecycle: true });
    },
    meta: {
      errorMessage: "Failed to trim cube"
    }
  });
}
